module.exports = __webpack_public_path__ + "assets/defaultHeader.c360eda4.svg";